import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Formik } from "formik";
import {
  Autocomplete,
  createTheme,
  Divider,
  FormHelperText,
  Grid2,
  IconButton,
  TextField,
  ThemeProvider,
  Typography,
  useTheme,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
} from "@mui/material";
import * as Yup from "yup";
import { useState } from "react";
import {
  useGetPackagesQuery,
  useLazyGetPackagesQuery,
} from "store/slices/apis/packageSlice";
import { useGetContractorQuery } from "store/slices/apis/contractors";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import { useEditKeyRiskMutation } from "store/slices/apis/keyRiskSlice";
import DragAndDropUpload from "components/FileUploader/DragAndDropUpload";
import { FaRegFileLines } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import { useEditKeyChangeMutation } from "store/slices/apis/keyChangeTrackerSlice";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

const Statuses = [
  { label: "Submitted", value: "Submitted" },
  { label: "Rejected", value: "Rejected" },
  { label: "Approved", value: "Approved" },
];

export default function EditChangeTracker(props) {
  const {
    open,
    cancelIssue,
    openNotification,
    data,
    isViewIssueModal,
    refetch,
  } = props;
  const newtheme = useTheme();
  const { projectId } = useParams();
  const [files, setFiles] = useState([]);
  const [dense, setDense] = useState(false);
  const [secondary, setSecondary] = useState(false);
  const { data: packages } = useGetPackagesQuery({ projectId: projectId });
  const { data: contractors } = useGetContractorQuery();
  const [getSubPackage1, { data: subPackageList1 }] = useLazyGetPackagesQuery();

  const [
    editKeyChange,
    { data: editKeyRiskRes, isLoading, isSuccess, isError, error },
  ] = useEditKeyChangeMutation();

  const [formData, setFormData] = useState({
    package: data?.package,
    subPackage1: data?.sub_package1,
    contractor_number: data?.contractor_number,
    consultant_contractor: data?.consultant_contractor,
    change_raised_to: data?.change_raised_to,
    change_received_on: data?.change_received_on,
    change_raised_by_refrence: data?.change_raised_by_refrence,
    change_raised_by_date_received: data?.change_raised_by_date_received,
    reason_for_change: data?.reason_for_change,
    change_raised_to_reference: data?.change_raised_to_reference,
    change_raised_to_date_of_response: data?.change_raised_to_date_of_response,
    change_raised_to_position: data?.change_raised_to_position,
    change_raised_by_estimate_cost_impact:
      data?.change_raised_by_estimate_cost_impact,
    change_raised_to_estimate_cost_impact:
      data?.change_raised_to_estimate_cost_impact,
    approved_cost_impact: data?.approved_cost_impact,
    change_raised_by_estimate_time_impact:
      data?.change_raised_by_estimate_time_impact,
    change_raised_to_estimate_time_impact:
      data?.change_raised_to_estimate_time_impact,
    approved_time_impact: data?.approved_time_impact,
    actual_date_of_closure: data?.actual_date_of_closure,
    description_of_change: data?.description_of_change,
    status: data?.status,
    
  });

  useEffect(() => {
    getSubPackage1({ projectId: projectId, type: "subPackage1" });
  }, [open]);

  const theme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            border: "2px solid #e6e6e6",
            "& .MuiFilledInput-input": {
              backgroundColor: "#fff",
              color: "#252525",
              fontSize: "16px",
            },
            "& .MuiFilledInput-root::before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root::after": {
              borderBottom: `2px solid ${newtheme?.customSettings?.themeColor}`,
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#696969",
              fontSize: "14px",
            },
            "& .MuiFormLabel-root": {
              fontSize: "15px",
            },
            "& .MuiFilledInput-root.Mui-disabled:before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root": {
              backgroundColor: "#fff",
            },
            "& .MuiFilledInput-input": {
              backgroundColor: "none",
              fontSize: "14px",
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#696969",
            },
            "& .MuiFilledInput-root.Mui-disabled": {
              backgroundColor: "#fff",
              color: "inherit",
            },
            "& .MuiFilledInput-input.Mui-disabled": {
              WebkitTextFillColor: "#696969",
              opacity: "none",
            },
          },
        },
      },
    },
  });

  const handleClose = () => { };

  const validationSchema = Yup.object({
    package: Yup.string().required("Category is required"),
    subPackage1: Yup.string().required("Sub Category 1 is required"),
    contractor_number: Yup.string().required("Contractor Number is required"),
    // consultant_contractor: Yup.string().required(
    //   "Consultant Contractor is required"
    // ),
    change_raised_to: Yup.string().required("Change Raised To is required"),
    change_received_on: Yup.date()
      .required("Change Received On is required")
      .nullable()
      .typeError("Change Received On must be a valid date"),
    change_raised_by_refrence: Yup.string().required(
      "Change Raised By Reference is required"
    ),
    change_raised_by_date_received: Yup.date()
      .required("Change Raised By Date Received is required")
      .nullable()
      .typeError("Change Raised By Date Received must be a valid date"),
    reason_for_change: Yup.string().required("Reason For Change is required"),
    change_raised_to_reference: Yup.string().required(
      "Change Raised to Reference for Change is required"
    ),
    change_raised_to_date_of_response: Yup.date()
      .required("Change Raised To Date Of Response is required")
      .nullable()
      .typeError("Change Raised To Date Of Response must be a valid date"),
    change_raised_to_position: Yup.string().required(
      "Change Raised To Position is required"
    ),
    change_raised_by_estimate_cost_impact: Yup.string().required(
      "Change Raised By Estimate Cost Impact is required"
    ),
    approved_cost_impact: Yup.string().required(
      "Approved Cost Impact is required"
    ),
    change_raised_to_estimate_cost_impact: Yup.string().required(
      "Change Raised To Estimate Cost Impact is required"
    ),
    change_raised_by_estimate_time_impact: Yup.string().required(
      "Change Raised By Estimate Time Impact is required"
    ),
    change_raised_to_estimate_time_impact: Yup.string().required(
      "Change Raised To Estimate Time Impact is required"
    ),
    approved_time_impact: Yup.string().required(
      "Approved Time Impact is required"
    ),
    actual_date_of_closure: Yup.date()
      .required("Actual Date of Closure is required")
      .nullable()
      .typeError("Actual Date of Closure must be a valid date"),
    description_of_change: Yup.string().required(
      "Description of Change is required"
    ),
    status: Yup.string().required("Status is required"),
  });

  const handleDrop = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      openNotification("File type must be image/*");
      return;
    }
    const newFiles = acceptedFiles.filter(
      (file) => !files.some((f) => f.name === file.name)
    );

    if (newFiles.length > 0) {
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };

  const handleRemoveFile = (fileName) => {
    setFiles(files.filter((file) => file.name !== fileName));
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    let reqBody = {
      package: values.package,
      sub_package1: values.subPackage1,
      contractor_number: values.contractor_number,
      consultant_contractor: values.consultant_contractor,
      change_raised_to: values.change_raised_to,
      change_received_on:
        values?.change_received_on && dayjs(values.change_received_on).isValid()
          ? dayjs(values.change_received_on).format("YYYY-MM-DD") +
          "T00:00:00.000Z"
          : null,
      change_raised_by_refrence: values.change_raised_by_refrence,
      change_raised_by_date_received:
        values?.change_raised_by_date_received &&
          dayjs(values.change_raised_by_date_received).isValid()
          ? dayjs(values.change_raised_by_date_received).format("YYYY-MM-DD") +
          "T00:00:00.000Z"
          : null,
      reason_for_change: values.reason_for_change,
      change_raised_to_reference: values.change_raised_to_reference,
      change_raised_to_date_of_response:
        values?.change_raised_to_date_of_response &&
          dayjs(values.change_raised_to_date_of_response).isValid()
          ? dayjs(values.change_raised_to_date_of_response).format(
            "YYYY-MM-DD"
          ) + "T00:00:00.000Z"
          : null,
      change_raised_to_position: values.change_raised_to_position,
      change_raised_by_estimate_cost_impact:
        values.change_raised_by_estimate_cost_impact,
      change_raised_to_estimate_cost_impact:
        values.change_raised_to_estimate_cost_impact,
      approved_cost_impact: values?.approved_cost_impact,
      change_raised_by_estimate_time_impact:
        values.change_raised_by_estimate_time_impact,
      change_raised_to_estimate_time_impact:
        values.change_raised_to_estimate_time_impact,
      approved_time_impact: values.approved_time_impact,
      actual_date_of_closure:
        values?.actual_date_of_closure &&
          dayjs(values.actual_date_of_closure).isValid()
          ? dayjs(values.actual_date_of_closure).format("YYYY-MM-DD") +
          "T00:00:00.000Z"
          : null,
      description_of_change: values.description_of_change,
      status: values.status,
      change_id: data?.change_id,
      projectId: projectId,
      project: data?.project,
      workflowApprovalId: data?.workflowApprovalId,
      change_number: data?.change_number,
    };

    try {
      const formData = new FormData();
      formData.append("changeJson", JSON.stringify({ ...reqBody }));
      formData.append("file", files);
      const response = await editKeyChange({
        id: data?.change_id,
        body: formData,
      }).unwrap();
      if (response?.status == "Success") {
        openNotification(
          response?.message || "Change Order updated successfully",
          "success"
        );
        resetForm();
        refetch();
        cancelIssue();
      } else {
        openNotification("Error in change order updation");
      }
    } catch (error) {
      console.log("errr", error);

      openNotification(error?.data?.message, "error");
    } finally {
      setSubmitting(false);
    }
  };

  const CustomCalendarIcon = (props) => (
      <CalendarIcon {...props} style={{ width: 26, height: 26, fill:"#696969 ", stroke:"#696969", strokeWidth:4 }} />
    );

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            overflowY: "inherit",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "20px", color: "#696969" }}>
          {isViewIssueModal ? "View" : "Edit"} Change Order
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancelIssue}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
          <CrossIcon style={{ fontSize: "20px", width:"20px", height:"20px", fill:"#808080" }} />
        </IconButton>
        <Divider sx={{ w: 1 }} />
        <DialogContent>
          <ThemeProvider theme={theme}>
            <Box sx={{ mt: 1 }}>
              <Formik
                initialValues={formData}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                  setTouched,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography
                          variant="h4"
                          gutterBottom
                          sx={{ fontSize: "20px", color: "#252525" }}
                        >
                          {isViewIssueModal ? "View" : "Edit"} Categories
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Autocomplete
                          options={(packages?.data || [])?.filter(
                            (option) => option
                          )}
                          disabled={isViewIssueModal}
                          getOptionLabel={(option) => option}
                          value={
                            packages?.data?.find(
                              (option) => option === values.package
                            ) || null
                          }
                          onChange={(_, newValue) => {
                            setFieldValue(
                              "package",
                              newValue ? newValue : ""
                            );
                            setFieldValue("subPackage1", "");
                          }}
                          onBlur={() =>
                            setTouched({ ...touched, package: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Category"
                              name="package"
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.package && errors?.package && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.package}`}</FormHelperText>
                        )}
                      </Grid>
                      {values?.package && (
                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                            // options={subPackageList1?.data}
                            options={(subPackageList1?.data || [])?.filter(
                              (option) => option
                            )}
                            disabled={isViewIssueModal}
                            getOptionLabel={(option) => option}
                            value={
                              subPackageList1?.data?.find(
                                (option) =>
                                  option === values?.subPackage1
                              ) || null
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage1",
                                newValue ? newValue : ""
                              );
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage1: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 1"
                                name="subPackage1"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage1 && errors?.subPackage1 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage1}`}</FormHelperText>
                          )}
                        </Grid>
                      )}
                    </Grid>
                    <Divider
                      sx={{
                        width: "100%",
                        mb: 2,
                        mt: 2,
                        borderBottomWidth: "medium",
                      }}
                    />
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography
                          variant="h4"
                          gutterBottom
                          sx={{ fontSize: "20px", color: "#252525" }}
                        >
                          {isViewIssueModal ? "View" : "Edit"} Change Order
                          Details
                        </Typography>
                      </Grid>
                      {/* <Grid item xs={12} sm={6}>
                        <Autocomplete
                          options={contractors?.data}
                          getOptionLabel={(option) => option.name}
                          disabled={isViewIssueModal}
                          value={
                            contractors?.data.find(
                              (option) => option.id === values.contractor
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "contractor",
                              newValue ? newValue.id : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, contractor: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Contractor"
                              name="contractor"
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.contractor && errors?.contractor && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.contractor}`}</FormHelperText>
                        )}
                      </Grid> */}

                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Contract Number"
                          name="contractor_number"
                          fullWidth
                          value={values?.contractor_number}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, contractor_number: true })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.contractor_number &&
                          errors?.contractor_number && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.contractor_number}`}</FormHelperText>
                          )}
                      </Grid>

                      {/* <Grid item xs={12} sm={6}>
                        <TextField
                          label="Consultant Contractor"
                          name="consultant_contractor"
                          fullWidth
                          value={values?.consultant_contractor}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              consultant_contractor: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.consultant_contractor &&
                          errors?.consultant_contractor && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.consultant_contractor}`}</FormHelperText>
                          )}
                      </Grid> */}

                      <Grid item xs={12} sm={6}>
                        <Autocomplete
                          options={contractors?.data}
                          getOptionLabel={(option) => option.name}
                          value={
                            contractors?.data.find(
                              (option) => option.name === values.consultant_contractor
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "consultant_contractor",
                              newValue ? newValue.name : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, consultant_contractor: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Consultant/Contractor"
                              name="consultant_contractor"
                              // error={touched.contractor && Boolean(errors.contractor)}
                              // helperText={touched.contractor && errors.contractor}
                              // slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.consultant_contractor && errors?.consultant_contractor && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.consultant_contractor}`}</FormHelperText>
                        )}
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Change Raised To"
                          name="change_raised_to"
                          fullWidth
                          value={values?.change_raised_to}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, change_raised_to: true })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.change_raised_to &&
                          errors?.change_raised_to && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.change_raised_to}`}</FormHelperText>
                          )}
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Change received on"
                            value={
                              values?.change_received_on
                                ? dayjs(values.change_received_on)
                                : null
                            }
                            format="DD-MM-YYYY"
                            disabled={isViewIssueModal}
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "change_received_on",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                            slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                change_received_on: true,
                              })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 16, fontWeight: 400 },
                                },
                                inputProps: {
                                  style: { height: "20px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 16,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                          {touched?.change_received_on &&
                            errors?.change_received_on && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.change_received_on}`}</FormHelperText>
                            )}
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Change Raised by Refrence"
                          name="change_raised_by_refrence"
                          fullWidth
                          value={values?.change_raised_by_refrence}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              change_raised_by_refrence: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.change_raised_by_refrence &&
                          errors?.change_raised_by_refrence && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.change_raised_by_refrence}`}</FormHelperText>
                          )}
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Change Raised by Date Received"
                            value={
                              values?.change_raised_by_date_received
                                ? dayjs(values.change_raised_by_date_received)
                                : null
                            }
                            format="DD-MM-YYYY"
                            disabled={isViewIssueModal}
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "change_raised_by_date_received",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                            slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                change_raised_by_date_received: true,
                              })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 16, fontWeight: 400 },
                                },
                                inputProps: {
                                  style: { height: "20px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 16,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                          {touched?.change_raised_by_date_received &&
                            errors?.change_raised_by_date_received && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.change_raised_by_date_received}`}</FormHelperText>
                            )}
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Reason for Change"
                          name="reason_for_change"
                          fullWidth
                          value={values?.reason_for_change}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, reason_for_change: true })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.reason_for_change &&
                          errors?.reason_for_change && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.reason_for_change}`}</FormHelperText>
                          )}
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Change Raised to Reference"
                          name="change_raised_to_reference"
                          fullWidth
                          value={values?.change_raised_to_reference}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              change_raised_to_reference: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.change_raised_to_reference &&
                          errors?.change_raised_to_reference && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.change_raised_to_reference}`}</FormHelperText>
                          )}
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Change Raised to Date of Response"
                            value={
                              values?.change_raised_to_date_of_response
                                ? dayjs(
                                  values.change_raised_to_date_of_response
                                )
                                : null
                            }
                            format="DD-MM-YYYY"
                            disabled={isViewIssueModal}
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "change_raised_to_date_of_response",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                            slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                change_raised_to_date_of_response: true,
                              })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 16, fontWeight: 400 },
                                },
                                inputProps: {
                                  style: { height: "20px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 16,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                          {touched?.change_raised_to_date_of_response &&
                            errors?.change_raised_to_date_of_response && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.change_raised_to_date_of_response}`}</FormHelperText>
                            )}
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Change Raised to Position"
                          name="change_raised_to_position"
                          fullWidth
                          value={values?.change_raised_to_position}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              change_raised_to_position: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.change_raised_to_position &&
                          errors?.change_raised_to_position && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.change_raised_to_position}`}</FormHelperText>
                          )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Change Raised by Estimate Cost Impact"
                          name="change_raised_by_estimate_cost_impact"
                          fullWidth
                          value={values?.change_raised_by_estimate_cost_impact}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              change_raised_by_estimate_cost_impact: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.change_raised_by_estimate_cost_impact &&
                          errors?.change_raised_by_estimate_cost_impact && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.change_raised_by_estimate_cost_impact}`}</FormHelperText>
                          )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Change Raised to Estimate Cost Impact"
                          name="change_raised_to_estimate_cost_impact"
                          fullWidth
                          value={values?.change_raised_to_estimate_cost_impact}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              change_raised_to_estimate_cost_impact: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.change_raised_to_estimate_cost_impact &&
                          errors?.change_raised_to_estimate_cost_impact && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.change_raised_to_estimate_cost_impact}`}</FormHelperText>
                          )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Approved Cost Impact"
                          name="approved_cost_impact"
                          fullWidth
                          value={values?.approved_cost_impact}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              approved_cost_impact: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.approved_cost_impact &&
                          errors?.approved_cost_impact && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.approved_cost_impact}`}</FormHelperText>
                          )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Change Raised by Estimate Time Impact"
                          name="change_raised_by_estimate_time_impact"
                          fullWidth
                          value={values?.change_raised_by_estimate_time_impact}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              change_raised_by_estimate_time_impact: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.change_raised_by_estimate_time_impact &&
                          errors?.change_raised_by_estimate_time_impact && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.change_raised_by_estimate_time_impact}`}</FormHelperText>
                          )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Change Raised to Estimate Time Impact"
                          name="change_raised_to_estimate_time_impact"
                          fullWidth
                          value={values?.change_raised_to_estimate_time_impact}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              change_raised_to_estimate_time_impact: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.change_raised_to_estimate_time_impact &&
                          errors?.change_raised_to_estimate_time_impact && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.change_raised_to_estimate_time_impact}`}</FormHelperText>
                          )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Approved Time Impact"
                          name="approved_time_impact"
                          fullWidth
                          value={values?.approved_time_impact}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              approved_time_impact: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.approved_time_impact &&
                          errors?.approved_time_impact && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.approved_time_impact}`}</FormHelperText>
                          )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Actual Date of Closure"
                            value={
                              values?.actual_date_of_closure
                                ? dayjs(values.actual_date_of_closure)
                                : null
                            }
                            format="DD-MM-YYYY"
                            disabled={isViewIssueModal}
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "actual_date_of_closure",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                            slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                actual_date_of_closure: true,
                              })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 16, fontWeight: 400 },
                                },
                                inputProps: {
                                  style: { height: "20px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 16,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                          {touched?.actual_date_of_closure &&
                            errors?.actual_date_of_closure && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.actual_date_of_closure}`}</FormHelperText>
                            )}
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Autocomplete
                          options={Statuses}
                          getOptionLabel={(option) => option?.label}
                          disabled={isViewIssueModal}
                          value={
                            Statuses.find(
                              (option) => option.label === values?.status
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "status",
                              newValue ? newValue.label : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, status: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Status"
                              name="status"
                              // error={touched?.package && Boolean(errors?.package)}
                              // helperText={touched?.package && errors?.package}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.status && errors?.status && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.status}`}</FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Description of Change"
                          name="description_of_change"
                          fullWidth
                          multiline
                          value={values?.description_of_change}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              description_of_change: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.description_of_change &&
                          errors?.description_of_change && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.description_of_change}`}</FormHelperText>
                          )}
                      </Grid>

                      {/* <Grid2 size={12}>
                                                {issueDetail?.data?.files?.length > 0 &&
                                                    <>
                                                        <List dense={dense}>
                                                            {issueDetail?.data?.files?.map((file, index) => (
                                                                <ListItem
                                                                    key={index}
                                                                    sx={{ padding: 0 }}
                                                                    secondaryAction={
                                                                        <IconButton edge="end" aria-label="delete" role="link" onClick={() => handleRemoveFile(index)}>
                                                                            <RxCross2 />
                                                                        </IconButton>
                                                                    }
                                                                >
                                                                    <ListItemAvatar>
                                                                        <Avatar sx={{ background: 'none' }}>
                                                                            <FaRegFileLines fontSize="inherit" style={{ color: '#474747' }} />
                                                                        </Avatar>
                                                                    </ListItemAvatar>
                                                                    <ListItemText
                                                                        primary={
                                                                            <span
                                                                                style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                                                                                onClick={() => {
                                                                                    window.open(`${API_END_POINT}${file?.name}`, "_blank");
                                                                                }}
                                                                            >
                                                                                {file?.name}
                                                                            </span>
                                                                        }
                                                                        secondary={secondary ? 'Secondary text' : null}
                                                                    />
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                    </>
                                                }
                                            </Grid2> */}

                      <Grid item xs={12}>
                        {files.length > 0 && (
                          <>
                            <Typography
                              variant="h6"
                              gutterBottom
                              style={{
                                color: "#474747",
                                fontWeight: "400",
                                fontSize: "16px",
                              }}
                            >
                              Uploaded Files
                            </Typography>

                            <List dense>
                              {files.map((file, index) => (
                                <ListItem
                                  key={index}
                                  sx={{
                                    padding: 0,
                                  }}
                                  secondaryAction={
                                    <IconButton
                                      edge="end"
                                      aria-label="delete"
                                      onClick={() =>
                                        handleRemoveFile(file.name)
                                      }
                                    >
                                      <RxCross2 />
                                    </IconButton>
                                  }
                                >
                                  <ListItemAvatar>
                                    <Avatar sx={{ background: "none" }}>
                                      <FaRegFileLines
                                        fontSize="inherit"
                                        style={{ color: "#474747" }}
                                      />
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText primary={`${file.name}`} />
                                </ListItem>
                              ))}
                            </List>
                          </>
                        )}
                      </Grid>
                      {!isViewIssueModal && (
                        <Grid item xs={12}>
                          <DragAndDropUpload
                            onDrop={handleDrop}
                            multi={true}
                            fileType="both"
                          />
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        {/* <Button
                          onClick={cancelIssue}
                          variant="outlined"
                          sx={{
                            color: `${newtheme?.customSettings?.themeColor}`,
                            border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                            padding: "6px 20px",
                            fontWeight: "500",
                            textTransform: "none",
                            float: "right",
                            fontSize: "16px",
                            marginBottom: "20px",
                          }}
                        >
                          Cancel
                        </Button> */}
                        {!isViewIssueModal && (
                          <Button
                            type="submit"
                            loading={isLoading}
                            variant="contained"
                            sx={{
                              marginRight: "20px",
                              backgroundColor: `${newtheme?.customSettings?.themeColor}`,
                              color: "#FFF",
                              padding: "6px 20px",
                              fontWeight: "500",
                              textTransform: "none",
                              float: "right",
                              fontSize: "16px",
                            }}
                          >
                            Edit Change Order
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </Box>
          </ThemeProvider>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
